import React from 'react';
import { Modal, Rate } from 'antd';
import { LeftOutlined, RightOutlined, CloseOutlined } from '@ant-design/icons';
import { IPhotoWithReview } from '../component';

interface PhotoGalleryModalProps {
    photos: IPhotoWithReview[];
    initialIndex: number;
    onClose: () => void;
}

export const PhotoGalleryModal: React.FC<PhotoGalleryModalProps> = ({ photos, initialIndex, onClose }) => {
    const [currentIndex, setCurrentIndex] = React.useState(initialIndex);

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % photos.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + photos.length) % photos.length);
    };

    const currentItem = photos[currentIndex];
    const { photo, review } = currentItem;

    const getBestUrl = (p: typeof photo) => {
        const sorted = [...p.versions].sort((a, b) => (b.width * b.height) - (a.width * a.height));
        return sorted[0]?.url || '';
    };

    const formatDate = (dateStr: string) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    };

    return (
        <Modal
            visible={true}
            onCancel={onClose}
            footer={null}
            closeIcon={<CloseOutlined style={{ color: '#fff', fontSize: '20px' }} />}
            width="100vw"
            className="photo-gallery-modal"
            centered
            bodyStyle={{ padding: 0, height: '100vh', background: 'rgba(0,0,0,0.9)' }}
        >
            <div className="gallery-layout">
                <div className="main-image-section">
                    <button className="nav-btn prev" onClick={handlePrev}>
                        <LeftOutlined />
                    </button>

                    <div className="image-container">
                        <img src={getBestUrl(photo)} alt="Traveler" />
                    </div>

                    <button className="nav-btn next" onClick={handleNext}>
                        <RightOutlined />
                    </button>

                    <div className="photo-counter">
                        {currentIndex + 1} / {photos.length}
                    </div>
                </div>

                <div className="review-info-section">
                    <div className="user-info">
                        <div className="avatar">{review.userName[0].toUpperCase()}</div>
                        <div>
                            <div className="user-name">{review.userName}</div>
                            <div className="date">{formatDate(review.publishedDate)}</div>
                        </div>
                    </div>

                    <div className="rating-row">
                        <Rate disabled defaultValue={review.rating} />
                        <span className="review-title">{review.title}</span>
                    </div>

                    <div className="comment">
                        {review.text}
                    </div>
                </div>

                <div className="thumbnails-strip">
                    {photos.map((item, idx) => (
                        <div
                            key={idx}
                            className={`thumb-item ${idx === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(idx)}
                        >
                            <img src={item.photo.versions[0].url} alt={`thumb-${idx}`} />
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};
